/**
 * Opening book state slice
 */
export const bookSlice = {
    latestMoves: [],
    isLoading: false,
    error: null,
    stats: null, // { total, white, draws, black, whitePct, drawPct, blackPct }
    fen: null, // position `latestMoves` belongs to
    source: null, // "catalog" (pre-generated tree) | "lichess" (live explorer)
    opening: null, // "B22 Sicilian Defense: Alapin Variation", the deepest named position reached
};
